import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=dd56eb0e&scoped=true"
import script from "./Circle.vue?vue&type=script&lang=js"
export * from "./Circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd56eb0e",
  null
  
)

export default component.exports